import { render, staticRenderFns } from "./AddRoostersToTournamentStage.vue?vue&type=template&id=17ce71e4"
import script from "./AddRoostersToTournamentStage.vue?vue&type=script&lang=js"
export * from "./AddRoostersToTournamentStage.vue?vue&type=script&lang=js"
import style0 from "./AddRoostersToTournamentStage.vue?vue&type=style&index=0&id=17ce71e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports